import React from 'react';
import Hero from '../components/Hero';
import Mission from '../components/Mission';
import NewsSection from '../components/NewsSection';
import Impact from '../components/Impact';
import Testimonials from '../components/Testimonials';
import Contact from '../components/Contact';

const Home = () => {
  return (
    <>
      <Hero />
      <Mission />
      <NewsSection />
      <Impact />
      <Testimonials />
      <Contact />
    </>
  );
};

export default Home;
